import axios from 'axios';
import history from '../../history';

import { getStoredAuthToken, removeStoredAuthToken } from './localStorageService';
import * as fileDownload from 'js-file-download';

const defaults = {
  baseURL: process.env.REACT_APP_API_URL,
  fileUrl: process.env.REACT_APP_FILE_URL,
  headers: () => ({
    'Content-Type': 'application/json',
    Authorization: getStoredAuthToken() ? `Bearer ${getStoredAuthToken()}` : undefined,
  }),
  error: {
    code: 'INTERNAL_ERROR',
    message: 'Something went wrong, check your internet/contact administrator',
    server_error: 'Something went wrong, check your internet/contact administrator',
    status: 503,
    data: {},
  },
};

export const apiPaths = {
  OTP_REQUEST: '/api/auth/otp',
  OTP_LOGIN: '/api/auth/otplogin',
  USERS: '/api/users',
  AGENTS: '/api/agents',
  BANNERS: '/api/banners',
  SELLERS: '/api/sellers',
  TRANSACTIONS: '/api/transactions',
  CUSTOMERS: '/api/customers',
  WARRANTIES: '/api/warranties',
  PHONES: '/api/phones',
  STORES: '/api/stores',
  SERVICE_CENTERS: '/api/service_centers',
  INSURANCES: '/api/insurances',
  FILE: '/api/file-upload',
  ANALYTICS: '/api/analytics',
  AGENCY_REQUESTS: '/api/agency_requests',
  CONTACT_REQUESTS: '/api/contact_requests',
  CARD_REQUESTS: '/api/card_requests',
}

const handleApiError = (error, reject) => {
  console.error(error)
  if (error.response && error.response.data && error.response.data.message) {
    if (error.response.status === 500) {
      reject(defaults.error.server_error)
    }
    else if (error.response.status === 401) {
      // show toast?
      removeStoredAuthToken();
      history.push('/session/signin');
    } else {
      reject(error.response.data.message);
    }
  } else {
    reject(defaults.error.message);
  }
}

const api = (method, url, data) =>
  new Promise((resolve, reject) => {
    // console.log('axiosing', `${defaults.baseURL}${url}`, data)
    axios({
      url: `${defaults.baseURL}${url}`,
      method,
      headers: defaults.headers(),
      params: method === 'get' ? data : undefined,
      data: method !== 'get' ? data : undefined,
    }).then(
      response => {
        resolve(response.data);
      },
      error => {
        handleApiError(error, reject)
        // if (error.response && error.response.data && error.response.data.message) {
        //   if (error.response.status === 500) {
        //     reject(defaults.error.server_error)
        //   }
        //   else if (error.response.status === 401) {
        //     // show toast?
        //     removeStoredAuthToken();
        //     history.push('/session/signin');
        //   } else {
        //     reject(error.response.data.message);
        //   }
        // } else {
        //   reject(defaults.error.message);
        // }
      },
    );
  });

const fileUpload = (formData, onUploadProgress) =>
  new Promise((resolve, reject) => {
    axios.post(
      `${defaults.baseURL}${apiPaths.FILE}/upload`,
      formData,
      {
        headers: {
          ...defaults.headers(),
          'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
        },
        onUploadProgress
      },
    ).then(
      response => {
        resolve(response.data);
      },
      error => {
        handleApiError(error, reject)
      },
    );
  })
const getPhotoUrl = (url) => `${defaults.fileUrl}${url}`

const getFile = (url) =>
  new Promise((resolve, reject) => {
    axios.get(`${defaults.fileUrl}${url}`,
      {
        headers: {
          ...defaults.headers(),
        },
      },
    ).then(
      response => {
        resolve(response.data);
      },
      error => {
        // handleApiError(error, reject)
      },
    );
  })

const download = (url, method, data) =>
  new Promise((resolve, reject) => {
    axios({
      url: `${defaults.baseURL}${url}`,
      method,
      responseType: 'blob',
      headers: defaults.headers(),
      data: method !== 'get' ? data : undefined,
    }).then(
      response => {
        const fileName = response.headers['content-disposition'] && response.headers['content-disposition'].split('filename=')[1] ?
          response.headers['content-disposition'].split('filename=')[1].replaceAll('"', '') : 'export.csv'
        resolve(fileDownload(response.data, fileName))
      },
      error => {
        handleApiError(error, reject)
      },
    );
  });

// const optimisticUpdate = async (url: string, { updatedFields, currentFields, setLocalData }) => {
//   try {
//     setLocalData(updatedFields);
//     await api('put', url, updatedFields);
//   } catch (error) {
//     setLocalData(currentFields);
//     // toast.error(error);
//   }
// };

const Api = {
  get: (url, data) => api('get', url, data),
  post: (url, data) => api('post', url, data),
  list: (url, data) => api('post', `${url}/list`, data),
  put: (url, data) => api('put', url, data),
  patch: (url, data) => api('patch', url, data),
  delete: (url) => api('delete', url),
  undelete: (url) => api('patch', `${url}/undelete`),
  fileUpload: (formData, onUploadProgress) => fileUpload(formData, onUploadProgress),
  getFile: (url) => getFile(url),
  getPhotoUrl: (url) => getPhotoUrl(url),
  downloadWithFilters: (url, data) => download(url, 'post', data),
  // optimisticUpdate,
};

export default Api